import { render, staticRenderFns } from "./CreatorVideoInvite.vue?vue&type=template&id=bd5c1fe4&scoped=true&"
import script from "./CreatorVideoInvite.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoInvite.vue?vue&type=script&lang=js&"
import style0 from "./CreatorVideoInvite.vue?vue&type=style&index=0&id=bd5c1fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5c1fe4",
  null
  
)

export default component.exports